import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Hero.css';

const Hero = ({ data }) => {
    const [currentSlide, setCurrentSlide] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentSlide((prev) => (prev + 1) % data.banners.length);
        }, 5000);
        return () => clearInterval(interval);
    }, [data.banners.length]);

    const goToSlide = (index) => {
        setCurrentSlide(index);
    };

    return (
        <section className="hero" id="home">
            <div className="hero-slider">
                {data.banners.map((banner, index) => (
                    <div
                        key={index}
                        className={`hero-slide ${index === currentSlide ? 'active' : ''}`}
                        style={{ backgroundImage: `url(${banner.image})` }}
                    >
                        <div className="hero-overlay"></div>
                        <div className="hero-content">
                            <div className="container">
                                <div className="hero-text">
                                    <h1 className="hero-title">
                                        {banner.title || 'Welcome to Melbourne Nepalese Community West'}
                                    </h1>
                                    <p className="hero-subtitle">
                                        {banner.subTitle || 'Connecting and supporting the Nepali community in Melbourne\'s western suburbs'}
                                    </p>
                                    <div className="hero-buttons">
                                        <Link to="/membership#pricing" className="btn btn-primary">
                                            Become a Member
                                        </Link>
                                        <a href="#about" className="btn btn-outline">
                                            Learn More
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            <div className="hero-indicators">
                {data.banners.map((_, index) => (
                    <button
                        key={index}
                        className={`indicator ${index === currentSlide ? 'active' : ''}`}
                        onClick={() => goToSlide(index)}
                        aria-label={`Go to slide ${index + 1}`}
                    ></button>
                ))}
            </div>
        </section>
    );
};

export default Hero;
